import { FC, MouseEvent, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import { MuiEvent } from '@microservices/wiskey-react-table-component'

import { OpenFormProps } from '@pages/ConfiguredEntity/types'
import { ConfiguredEntityWithSearchAssistant } from '@pages/ConfiguredEntityWithSearchAssistant'

import { useFetchParameterPropertiesQuery } from '@redux/api/parameters.api'
import { openFormDialog } from '@redux/reducers/dialogWindowManager.reducer'

import { useAppDispatch } from '@hooks'
import {
  checkMaxOpenedWindowsCount,
  getInitialPositionWindow,
  transformCommonParametersToValues,
} from '@helpers'
import { getUrlForm } from '@helpers'
import { CLICK_EVENT_TYPE, COMMON_PARAMETERS, ENTITY } from '@constants'
import { DIALOG_WINDOW_TYPE, POSTObjectDataFilter } from '@types'

type ConfiguredEntityPageProps = {
  entityId?: number
  entityCode?: string
  type: ENTITY
  path: string
  title: string
  setSearchFilter?: (body: POSTObjectDataFilter) => void
  searchFilterBody?: POSTObjectDataFilter
  entityMinHeight?: number | string
  hideSA: boolean
}

export const ConfiguredEntityPage: FC<ConfiguredEntityPageProps> = ({
  entityId,
  entityCode,
  type,
  path,
  title,
  setSearchFilter,
  searchFilterBody,
  entityMinHeight = 0,
  hideSA,
}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { search = '', pathname = '' } = useLocation()
  const id = useMemo(() => uuid(), [])

  const { data: commonParameters } = useFetchParameterPropertiesQuery({
    code: COMMON_PARAMETERS.STATE,
  })

  const initialCommonParameters = useMemo(
    () => transformCommonParametersToValues(commonParameters),
    [commonParameters]
  )

  const handleOpenForm = (
    { entityType, ...formProps }: OpenFormProps,
    muiEvent: MouseEvent<HTMLButtonElement> | MuiEvent<MouseEvent>,
    type: CLICK_EVENT_TYPE
  ) => {
    if (
      (type === CLICK_EVENT_TYPE.ROW_CLICK && muiEvent.shiftKey) ||
      // TODO: WF-RN-7
      // Добавлены условия для открытия формы в окне из вью в рабочей области (СПАСАЕМ ГРУЗИЮ)
      type === CLICK_EVENT_TYPE.CELL_CLICK ||
      type === CLICK_EVENT_TYPE.ROW_CLICK ||
      type === CLICK_EVENT_TYPE.EDIT_CLICK ||
      type === CLICK_EVENT_TYPE.CREATE_CLICK
    ) {
      const { id, formCode, objectCode, viewCode, objectId, path, event, variables } = formProps

      if (checkMaxOpenedWindowsCount(initialCommonParameters)) {
        return
      }

      const initialPosition = getInitialPositionWindow(muiEvent)

      dispatch(
        openFormDialog({
          id,
          parentDialogId: null,
          type: DIALOG_WINDOW_TYPE.FORM,
          title: null,
          meta: {
            formCode,
            objectCode,
            objectId,
            viewCode,
            path,
            event,
            globalId: id,
            entityType,
            variables,
          },
          initialPosition,
        })
      )

      return
    }
    navigate(getUrlForm({ ...formProps }))
  }

  return (
    <ConfiguredEntityWithSearchAssistant
      enableStaticForms
      dialogId={id}
      entityCode={entityCode}
      entityId={entityId}
      entityMinHeight={entityMinHeight}
      hideSA={hideSA}
      path={path}
      pathname={pathname}
      search={search}
      searchFilterBody={searchFilterBody}
      setSearchFilter={setSearchFilter}
      title={title}
      type={type}
      onOpenForm={handleOpenForm}
    />
  )
}
